/**
 * Article RTE wrap, social share, and product-item reinit.
 * Loaded from sections/main-article.liquid as type="module".
 */

const SELECTOR = '[data-section-type="article"]'

function initSocialShare(node) {
  const button = node.querySelector('.social-share__button')
  const popup = node.querySelector('.social-sharing__popup')
  const copyButton = node.querySelector('.social-share__copy-url')
  const success = node.querySelector('.social-share__success-message')
  if (!button || !popup) return

  if (!navigator.clipboard?.writeText) copyButton?.classList.add('hidden')

  const close = () => {
    button.setAttribute('aria-expanded', 'false')
    popup.setAttribute('aria-hidden', 'true')
  }
  window.addEventListener('click', (evt) => {
    const inButton = evt.target.closest('.social-share__button') === button
    const inPopup = evt.target.closest('.social-sharing__popup') === popup
    if (!inPopup) close()
    if (inButton && button.getAttribute('aria-expanded') !== 'true') {
      button.setAttribute('aria-expanded', 'true')
      popup.setAttribute('aria-hidden', 'false')
    }
    if (evt.target.closest('.social-share__copy-url') === copyButton && copyButton) {
      navigator.clipboard.writeText(copyButton.dataset.url).then(
        () => {
          if (!success) return
          success.innerHTML = copyButton.dataset.successMessage
          success.classList.remove('hidden')
          popup.classList.add('social-sharing__popup--success')
          window.setTimeout(() => {
            success.classList.add('hidden')
            popup.classList.remove('social-sharing__popup--success')
          }, 2000)
        },
        () => {
          if (!success) return
          success.innerHTML = copyButton.dataset.errorMessage || 'Error copying link.'
        }
      )
    }
  })
}

function init(root) {
  if (root.dataset.articleInit) return
  root.dataset.articleInit = 'true'

  const share = root.querySelector('.social-share')
  if (share) initSocialShare(share)

  root.querySelectorAll('iframe').forEach((el) => {
    if (el.parentElement?.classList.contains('rte__iframe')) return
    const wrapper = document.createElement('div')
    wrapper.className = 'rte__iframe'
    el.parentNode.insertBefore(wrapper, el)
    wrapper.appendChild(el)
  })
  root.querySelectorAll('table').forEach((el) => {
    if (el.parentElement?.classList.contains('rte__table-wrapper')) return
    const wrapper = document.createElement('div')
    wrapper.className = 'rte__table-wrapper'
    wrapper.tabIndex = 0
    el.parentNode.insertBefore(wrapper, el)
    wrapper.appendChild(el)
  })

  document.dispatchEvent(new CustomEvent('product-item:reinit', { detail: { root } }))
  root.querySelectorAll('span.p').forEach((span) => {
    const parentDiv = span.closest('div')
    if (parentDiv && parentDiv.nextElementSibling?.tagName === 'H2') span.style.display = 'none'
  })
}

function initAll(scope = document) {
  if (scope.matches?.(SELECTOR)) init(scope)
  scope.querySelectorAll(SELECTOR).forEach(init)
}

initAll()
document.addEventListener('shopify:section:load', (event) => initAll(event.target))
